import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vileparletopunecabservice() {



  const cardData = {


  keyword: "Vile Parle to Pune Cab Service",

  headingDescription: "Trustline Cab provides reliable Vile Parle to Pune cab service with safe, comfortable, and affordable transportation for airport transfers, business travel, corporate meetings, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth highway travel, and a comfortable journey from Vile Parle to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to meet every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained cars, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Vile Parle to Pune taxi services.",

  topPlaces: [
    {
      title: "Amanora Park Town",
      description: "Amanora Park Town is a modern integrated township in Pune offering residential communities, commercial spaces, shopping areas, and lifestyle facilities. It is a popular destination for families, professionals, and visitors."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport is a major aviation hub connecting Pune with various cities across India. It is frequently used by business travelers, tourists, and passengers requiring reliable airport transfer services."
    },
    {
      title: "Yerwada",
      description: "Yerwada is an important commercial locality in Pune featuring IT companies, business offices, hotels, government establishments, and excellent connectivity to Pune Airport and central areas."
    },
    {
      title: "Pimple Saudagar",
      description: "Pimple Saudagar is a developed residential and commercial area known for premium housing projects, restaurants, shopping destinations, and convenient connectivity to Pimpri Chinchwad and IT hubs."
    },
    {
      title: "Talegaon MIDC",
      description: "Talegaon MIDC is an emerging industrial zone near Pune, featuring automobile companies, manufacturing units, logistics centers, and corporate facilities. It is a preferred destination for industrial travel."
    },
    {
      title: "Balewadi",
      description: "Balewadi is a growing commercial destination in Pune known for Balewadi High Street, business spaces, restaurants, sports facilities, and premium residential developments."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is a famous historical monument in Pune known for Maratha heritage, impressive architecture, and cultural importance. It is one of the city's most visited tourist attractions."
    },
    {
      title: "Pune Okayama Friendship Garden",
      description: "Pune Okayama Friendship Garden is a beautiful Japanese-style garden featuring greenery, peaceful surroundings, and landscaped views. It is a relaxing sightseeing destination for families and tourists."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station between Mumbai and Pune, famous for waterfalls, valleys, viewpoints, caves, and pleasant weather. It is a popular weekend getaway destination."
    },
    {
      title: "Rajmachi Fort",
      description: "Rajmachi Fort is a historic hill fort near Lonavala known for trekking trails, scenic mountain views, and natural beauty. It is a favorite destination for adventure lovers and photographers."
    }
  ],






"services": [
  {
    "name": "Vile Parle to Pune Cab Service",
    "description": "Book Vile Parle to Pune Cab Service with professional drivers, clean AC cars, affordable fares, doorstep pickup, and comfortable intercity travel."
  },
  {
    "name": "Vile Parle to Pune Cab Service Contact Number",
    "description": "Get Vile Parle to Pune Cab Service Contact Number for instant booking support, fare details, vehicle availability, and customer assistance."
  },
  {
    "name": "Santacruz to Pimpri Chinchwad Cab Service",
    "description": "Choose Santacruz to Pimpri Chinchwad Cab Service for reliable travel with experienced chauffeurs, premium vehicles, and smooth highway journeys."
  },
  {
    "name": "Santacruz to Pune Station Cab Fare",
    "description": "Check Santacruz to Pune Station Cab Fare with transparent pricing, flexible packages, and comfortable vehicle options."
  },
  {
    "name": "Mumbai to Pune Taxi Service",
    "description": "Book Mumbai to Pune Taxi Service with safe travel, professional drivers, clean AC vehicles, and reliable pickup facilities."
  },
  {
    "name": "Taxi Service in Vile Parle",
    "description": "Get Taxi Service in Vile Parle for local travel, airport transfers, and outstation journeys with comfortable cars."
  },
  {
    "name": "Nehru Nagar to Pune Cab Service",
    "description": "Reserve Nehru Nagar to Pune Cab Service with experienced drivers, affordable pricing, and dependable transportation."
  },
  {
    "name": "Sahara Airport to Pune Taxi Service",
    "description": "Book Sahara Airport to Pune Taxi Service with timely pickup, professional chauffeurs, and comfortable airport transfers."
  },
  {
    "name": "Sahara Airport to Pimpri Chinchwad Taxi Service",
    "description": "Choose Sahara Airport to Pimpri Chinchwad Taxi Service for safe airport travel with premium vehicles and reliable service."
  },
  {
    "name": "Mumbai Airport to Pune Taxi Online Booking",
    "description": "Complete Mumbai Airport to Pune Taxi Online Booking with instant confirmation, affordable fares, and multiple vehicle choices."
  },
  {
    "name": "Mumbai to Pune Taxi Fare",
    "description": "Check Mumbai to Pune Taxi Fare with transparent rates, affordable packages, and comfortable travel options."
  },
  {
    "name": "Mumbai to Pune Car Rental",
    "description": "Hire Mumbai to Pune Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and premium cars for long-distance travel."
  },
  {
    "name": "Mumbai to Pune Cab Charges",
    "description": "Get Mumbai to Pune Cab Charges with clear pricing, no hidden costs, and reliable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Pune Cab Fare",
    "description": "Find Mumbai to Pune Cab Fare with affordable rates, clean vehicles, and professional drivers."
  },
  {
    "name": "Mumbai to Pune Cab Booking",
    "description": "Book Mumbai to Pune Cab Booking online with quick confirmation, doorstep pickup, and reliable taxi service."
  },
  {
    "name": "Cab Service in Mumbai",
    "description": "Choose Cab Service in Mumbai for airport transfers, corporate travel, and outstation trips with trained chauffeurs."
  },
  {
    "name": "Cab Booking Mumbai",
    "description": "Complete Cab Booking Mumbai with easy reservation, affordable pricing, and quality vehicles."
  },
  {
    "name": "Mumbai Taxi Service",
    "description": "Get Mumbai Taxi Service with professional drivers, clean AC cars, and dependable transportation."
  },
  {
    "name": "Cheapest Cab Service in Mumbai",
    "description": "Book Cheapest Cab Service in Mumbai with budget-friendly fares and reliable travel solutions."
  },
  {
    "name": "Cab Service in Vile Parle",
    "description": "Choose Cab Service in Vile Parle for local and outstation travel with experienced chauffeurs."
  },
  {
    "name": "Best Cab in Vile Parle",
    "description": "Book Best Cab in Vile Parle with comfortable vehicles, affordable fares, and professional service."
  },
  {
    "name": "Kandivali to Pune Innova Crysta Cab",
    "description": "Reserve Kandivali to Pune Innova Crysta Cab for family travel with spacious seating and premium comfort."
  },
  {
    "name": "Vile Parle to Pune Cab",
    "description": "Book Vile Parle to Pune Cab with Sedan, Ertiga, Innova Crysta, and SUV options for safe travel."
  },
  {
    "name": "Vile Parle to Pune Taxi",
    "description": "Choose Vile Parle to Pune Taxi with affordable fares, AC vehicles, and experienced chauffeurs."
  },
  {
    "name": "Vile Parle to Pune One Way Cab",
    "description": "Travel with Vile Parle to Pune One Way Cab featuring fixed pricing, direct drop service, and comfortable vehicles."
  },
  {
    "name": "Vile Parle to Pune Taxi Booking",
    "description": "Complete Vile Parle to Pune Taxi Booking with instant confirmation and flexible travel schedules."
  },
  {
    "name": "Vile Parle to Pune Drop Taxi",
    "description": "Book Vile Parle to Pune Drop Taxi for economical one-way travel with professional drivers."
  },
  {
    "name": "Vile Parle to Pune Online Cab Booking",
    "description": "Use Vile Parle to Pune Online Cab Booking for quick reservations, transparent pricing, and reliable service."
  },
  {
    "name": "Vile Parle to Pune Private Cab",
    "description": "Hire Vile Parle to Pune Private Cab for private travel with complete comfort, privacy, and flexible timing."
  },
  {
    "name": "Vile Parle to Pune Outstation Cab",
    "description": "Choose Vile Parle to Pune Outstation Cab for safe highway journeys with experienced chauffeurs."
  },
  {
    "name": "Vile Parle to Pune Cheap Cab",
    "description": "Book Vile Parle to Pune Cheap Cab with affordable fares and dependable transportation."
  },
  {
    "name": "Vile Parle to Pune AC Cab Service",
    "description": "Travel comfortably with Vile Parle to Pune AC Cab Service featuring clean air-conditioned vehicles."
  },
  {
    "name": "Vile Parle to Pune Innova Cab",
    "description": "Reserve Vile Parle to Pune Innova Cab for premium family travel with spacious interiors."
  },
  {
    "name": "Vile Parle to Pune Taxi Fare",
    "description": "Check Vile Parle to Pune Taxi Fare with transparent charges and multiple vehicle options."
  },
  {
    "name": "Vile Parle East to Pune Cab",
    "description": "Book Vile Parle East to Pune Cab with reliable pickup and comfortable travel."
  },
  {
    "name": "Vile Parle West to Pune Cab",
    "description": "Choose Vile Parle West to Pune Cab for safe journeys with professional drivers."
  },
  {
    "name": "Vile Parle to Pune Round Trip Cab",
    "description": "Book Vile Parle to Pune Round Trip Cab with flexible return schedules, premium cars, and affordable pricing."
  },
  {
    "name": "Vile Parle to Pune Cab Per Km Rate",
    "description": "Check Vile Parle to Pune Cab Per Km Rate with transparent pricing and suitable vehicle options."
  },
  {
    "name": "Vile Parle to Pune Sedan Taxi",
    "description": "Choose Vile Parle to Pune Sedan Taxi for comfortable travel with economical fares and smooth rides."
  },
  {
    "name": "Vile Parle to Pune Innova Crysta Cab",
    "description": "Hire Vile Parle to Pune Innova Crysta Cab for luxury comfort, spacious seating, and premium chauffeur service."
  }
],
"tableData": [
  ["Vile Parle to Pune Cab Service", "Vile Parle to Pune Cab Service Contact Number"],
  ["Santacruz to Pimpri Chinchwad Cab Service", "Santacruz to Pune Station Cab Fare"],
  ["Mumbai to Pune Taxi Service", "Taxi Service in Vile Parle"],
  ["Nehru Nagar to Pune Cab Service", "Sahara Airport to Pune Taxi Service"],
  ["Sahara Airport to Pimpri Chinchwad Taxi Service", "Mumbai Airport to Pune Taxi Online Booking"],
  ["Mumbai to Pune Taxi Fare", "Mumbai to Pune Car Rental"],
  ["Mumbai to Pune Cab Charges", "Mumbai to Pune Cab Fare"],
  ["Mumbai to Pune Cab Booking", "Cab Service in Mumbai"],
  ["Cab Booking Mumbai", "Mumbai Taxi Service"],
  ["Cheapest Cab Service in Mumbai", "Cab Service in Vile Parle"],
  ["Best Cab in Vile Parle", "Kandivali to Pune Innova Crysta Cab"],
  ["Vile Parle to Pune Cab", "Vile Parle to Pune Taxi"],
  ["Vile Parle to Pune Cab Service", "Vile Parle to Pune One Way Cab"],
  ["Vile Parle to Pune Taxi Booking", "Vile Parle to Pune Drop Taxi"],
  ["Vile Parle to Pune Online Cab Booking", "Vile Parle to Pune Private Cab"],
  ["Vile Parle to Pune Outstation Cab", "Vile Parle to Pune Cheap Cab"],
  ["Vile Parle to Pune AC Cab Service", "Vile Parle to Pune Innova Cab"],
  ["Vile Parle to Pune Taxi Fare", "Vile Parle East to Pune Cab"],
  ["Vile Parle West to Pune Cab", "Vile Parle to Pune Round Trip Cab"],
  ["Vile Parle to Pune Cab Per Km Rate", "Vile Parle to Pune Sedan Taxi"],
  ["Vile Parle to Pune Innova Crysta Cab", "Mumbai Airport to Pune Taxi Service"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Vile Parle to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable Vile Parle to Pune cab services with experienced drivers, well-maintained vehicles, and smooth intercity travel solutions."
  },
  {
    WhyChooseheading: "Convenient Pickup from Vile Parle",
    WhyChoosedescription: "Get easy pickup from Vile Parle East, Vile Parle West, Mumbai Airport area, hotels, offices, and residential locations with direct drop in Pune."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai Pune Route",
    WhyChoosedescription: "Our professional chauffeurs ensure safe and timely travel with excellent knowledge of Mumbai-Pune Expressway and highway routes."
  },
  {
    WhyChooseheading: "Comfortable Fleet Options",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your passenger count and travel needs."
  },
  {
    WhyChooseheading: "Affordable Vile Parle Pune Cab Fare",
    WhyChoosedescription: "Enjoy competitive cab rates with transparent pricing and clear fare details before booking your journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Book flexible one-way cabs, return trips, or customized travel packages based on your schedule and destination."
  },
  {
    WhyChooseheading: "Ideal for Airport & Business Travel",
    WhyChoosedescription: "Our Vile Parle to Pune cabs are suitable for Mumbai Airport transfers, corporate meetings, family travel, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Get quick booking assistance, instant confirmation, and reliable customer support whenever you need a cab from Vile Parle to Pune."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Vile Parle to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Vile Parle to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Vile Parle to Pune?",
    answer: "Yes, one-way cab booking is available from Vile Parle to Pune with flexible pickup and drop options."
  },
  {
    question: "Do you provide pickup from Vile Parle East and West?",
    answer: "Yes, pickup services are available from both Vile Parle East and Vile Parle West along with nearby Mumbai locations."
  },
  {
    question: "Can I book a Vile Parle to Pune cab from Mumbai Airport?",
    answer: "Yes, we provide direct airport transfer cabs from Mumbai Airport and nearby Vile Parle areas to Pune."
  },
  {
    question: "Which vehicles are available for Vile Parle to Pune travel?",
    answer: "We offer Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable travel."
  },
  {
    question: "Is Vile Parle to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 for convenient travel according to your preferred timing."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking quotation."
  },
  {
    question: "Can I schedule my Vile Parle to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup time."
  },
  {
    question: "Do you provide cabs for corporate travel from Vile Parle to Pune?",
    answer: "Yes, our cab services are suitable for business meetings, office travel, employee transportation, and professional journeys."
  },
  {
    question: "How can I book Vile Parle to Pune Cab Service with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Kulkarni",
    feedback: "Trustline Travels provided a smooth Vile Parle to Pune journey with timely pickup, a clean vehicle, and a professional driver. The complete ride was comfortable and reliable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Sharma",
    feedback: "The booking experience was simple and the service quality was excellent. The comfortable cab and polite driver made our Vile Parle to Pune trip stress-free.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vile Parle to Pune Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/vile-parle-to-pune-cab-service.webp",
  "description":
    "Book Vile Parle to Pune Cab Service with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Vile Parle, Santacruz, Sahara Airport, and Mumbai Airport to Pune, Pimpri Chinchwad, Pune Railway Station, and all Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/vile-parle-to-pune-cab-service"
  }
};





  return (
    <div>
<Helmet>
  <title>Vile Parle to Pune Cab Service | Airport Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Vile Parle to Pune Cab Service with Trustline Travels for reliable one-way and round-trip taxi services. We offer cabs from Vile Parle, Santacruz, Sahara Airport, and Mumbai Airport to Pune, Pimpri Chinchwad, Pune Railway Station, and nearby areas with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7."
  />

  <meta
    name="keywords"
    content="vile parle to pune cab service, vile parle to pune cab service contact number, santacruz to pimpri chinchwad cab service, santacruz to pune station cab fare, mumbai to pune taxi service, taxi service in vile parle, nehru nagar to pune cab service, sahara airport to pune taxi service, sahara airport to pimpri chinchwad taxi service, mumbai airport to pune taxi online booking, mumbai to pune taxi fare, mumbai to pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/111.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vileparletopunecabservice;